export const STANDARD_COLORS = ['White', 'White Granite', 'Gray Granite'];

// Returns "Ships in 1-7 days" / "Ships in 1-4 weeks" for items whose product
// uses the standard/custom color grouping, otherwise null (Frozin, Rad Pad, etc.)
export function shippingEstimate(item) {
  if (!item || item.category === 'frozin-400-products' || !item.selectedColor) return null;
  const colors = item.colors || [];
  const hasStandard = colors.some((c) => STANDARD_COLORS.includes(c));
  const hasCustom = colors.some((c) => !STANDARD_COLORS.includes(c));
  if (!hasStandard || !hasCustom) return null;
  return STANDARD_COLORS.includes(item.selectedColor) ? 'Ships in 1-7 days' : 'Ships in 1-4 weeks';
}
